import React from "react";
import { Drawer, Typography, CircularProgress, Box } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import PropTypes from "prop-types";

import { useStyles } from "./SideDrawer.styles";

const SideDrawer = ({ open, anchor, onClose, content, title, loading }) => {
  const classes = useStyles();

  return (
    <div id="drawer">
      <Drawer anchor={anchor} open={open}>
        <Box display="flex" flexDirection="column" height="100%">
          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
            m={(3.5, 4, 0, 4)}
          >
            <Typography variant="h5" className={classes.title}>
              {title}
            </Typography>
            <Close onClick={onClose} className={classes.close}></Close>
          </Box>
          {loading ? (
            <CircularProgress color="primary" className={classes.center} />
          ) : (
            content
          )}
        </Box>
      </Drawer>
    </div>
  );
};

SideDrawer.propTypes = {
  anchor: PropTypes.string,
  content: PropTypes.node,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  loading: PropTypes.bool,
};

export { SideDrawer };
